import React from 'react';
import { Link } from 'react-router-dom';
import { LayoutDashboard, FileText, Clock, BarChart3, Settings, LogOut, Building2 } from 'lucide-react';
type TabType = 'overview' | 'quotes' | 'holds' | 'analytics';
interface SidebarProps {
  activeTab: TabType;
  setActiveTab: (tab: TabType) => void;
}
export function Sidebar({
  activeTab,
  setActiveTab
}: SidebarProps) {
  const navItems: {
    id: TabType;
    label: string;
    icon: React.ElementType;
  }[] = [{
    id: 'overview',
    label: 'Overview',
    icon: LayoutDashboard
  }, {
    id: 'quotes',
    label: 'Quotes',
    icon: FileText
  }, {
    id: 'holds',
    label: 'Active Holds',
    icon: Clock
  }, {
    id: 'analytics',
    label: 'Analytics',
    icon: BarChart3
  }];
  return <div className="w-64 bg-stone-950 text-stone-50 h-screen flex flex-col border-r border-stone-800 flex-shrink-0" data-id="element-672">
      {/* Brand */}
      <div className="h-16 flex items-center px-6 border-b border-stone-800" data-id="element-673">
        <Link to="/" className="font-serif text-xl tracking-tight text-stone-50 flex items-center gap-2" data-id="element-674">
          <div className="w-6 h-6 bg-red-600 flex items-center justify-center" data-id="element-675">
            <span className="font-serif text-sm font-bold text-white" data-id="element-676">B</span>
          </div>
          BlockQuote
        </Link>
      </div>

      {/* Resort Context */}
      <div className="p-6 border-b border-stone-800" data-id="element-677">
        <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-2" data-id="element-678">
          Current Portfolio
        </p>
        <div className="flex items-center gap-3" data-id="element-679">
          <div className="w-8 h-8 rounded bg-stone-800 flex items-center justify-center" data-id="element-680">
            <Building2 className="w-4 h-4 text-stone-400" data-id="element-681" />
          </div>
          <div data-id="element-682">
            <p className="font-medium text-sm text-stone-50" data-id="element-683">
              Moon Palace Resorts
            </p>
            <p className="text-xs text-stone-400 font-mono" data-id="element-684">6 Properties</p>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <div className="flex-1 py-6 px-4 space-y-1" data-id="element-685">
        <p className="font-mono text-xs uppercase tracking-widest text-stone-500 px-2 mb-4" data-id="element-686">
          Menu
        </p>
        {navItems.map(item => {
        const Icon = item.icon;
        const isActive = activeTab === item.id;
        return <button key={item.id} onClick={() => setActiveTab(item.id)} className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-md transition-colors text-sm font-medium ${isActive ? 'bg-red-600/10 text-red-600' : 'text-stone-400 hover:bg-stone-900 hover:text-stone-50'}`} data-id="element-687">
              <Icon className={`w-4 h-4 ${isActive ? 'text-red-600' : 'text-stone-500'}`} data-id="element-688" />
              {item.label}
            </button>;
      })}
      </div>

      {/* Bottom Actions */}
      <div className="p-4 border-t border-stone-800 space-y-1" data-id="element-689">
        <button className="w-full flex items-center gap-3 px-3 py-2.5 rounded-md transition-colors text-sm font-medium text-stone-400 hover:bg-stone-900 hover:text-stone-50" data-id="element-690">
          <Settings className="w-4 h-4 text-stone-500" data-id="element-691" />
          Settings
        </button>
        <Link to="/" className="w-full flex items-center gap-3 px-3 py-2.5 rounded-md transition-colors text-sm font-medium text-stone-400 hover:bg-stone-900 hover:text-stone-50" data-id="element-692">
          <LogOut className="w-4 h-4 text-stone-500" data-id="element-693" />
          Exit Demo
        </Link>
      </div>
    </div>;
}